









import { Pie } from 'vue-chartjs/legacy';
import Vue from 'vue';
import { ReportSpecByWeek } from '@/components/ReportControls.vue';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js';
import axios from 'axios';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default Vue.extend({
  name: 'PieChart',
  components: {
    Pie,
  },
  props: {
    chartId: {
      type: String,
      default: 'pie-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    spec: Object as () => ReportSpecByWeek,
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const { depot, from, to } = this.spec;
      return `${BASE_URL}/reports/customer-review-postcodes/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
    },
  },
  data() {
    return {
      chartData: {
        datasets: [
          {
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#0B234E', '#7fba50'],
            data: [] as number[],
          },
        ],
        labels: [] as string[],
      },
      chartOptions: {
        resizeDelay: 2,
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: 5,
        },
        plugins: {
          legend: {
            display: true,
            position: 'left',
          },
          title: {
            display: true,
            text: 'Top 10 Postcodes',
          },
        },
      },
    };
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        const response = await axios.get<{ postcode_data: [{ pcArea: string, countOf: number }],
        }>(this.dataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a) => a.codes),
          },
        });
        this.chartData.labels = response.data.postcode_data.map((item) => item.pcArea);
        this.chartData.datasets[0].data = response.data.postcode_data.map((item) => item.countOf);
      },
    },
  },
});
